const data = [
    {
        id: 'A',
        name: 'Ativo',
        class: 'green'
    },
    {
        id: 'I',
        name: 'Inativo',
        class: 'red'
    },
    {
        id: 'T',
        name: 'Em Conjunto',
        class: 'orange'
    },
    {
        id: 'C',
        name: 'Cancelado',
        class: 'grey'
    }
];

export default [...data];